import AnalyticsProvider from "../../lib/analyticsProvider";
const analytics = new AnalyticsProvider();

export const addToCartEvent = (addedItems, cart) => {
  try {
    addedItems.forEach((item) => {
      window.maestro.fireTrackEvent("addedToCart", { item, cart });
      const lineItem = cart.items.find((_lineItem) => _lineItem.id === item.id);
      if (!lineItem) return;
      const price = (lineItem.final_price / 100).toFixed(2);
      window.maestro.fireTrackEvent("productAdded", {
        "product category": lineItem.product_type,
        "product id": lineItem.product_id,
        "product name": lineItem.product_title,
        "product price": price,
        "variant id": lineItem.id,
        "variant name": lineItem.title,
        "variant price": price,
        "variant sku": lineItem.sku,
      });
    });

    const item = addedItems[0];
    analytics.liveIntent(
      item.id,
      item.final_price ? item.final_price / 100 : 1,
      item.quantity,
      Shopify.currency.active
    );
    analytics.googleAds(item.final_price ? item.final_price / 100 : 1);
  } catch (e) {
    console.error(e);
  }
};

export const addBundleToCartEvent = (bundleProduct, bundleItems, cart) => {
  try {
    // for each bundle item
    const bundleProductNames = [];
    const bundleVariantNames = [];
    bundleItems.forEach((item) => {
      const lineItem = cart.items.find(
        (lineItem) => lineItem.variant_id === item.id
      );
      const price = (lineItem.final_price / 100).toFixed(2);
      const eventData = {
        "product category": lineItem.product_type,
        "product id": lineItem.product_id,
        "product name": lineItem.product_title,
        "product price": price,
        "variant id": lineItem.id,
        "variant name": lineItem.title,
        "variant price": price,
        "variant sku": lineItem.sku,
        "bundle name": bundleProduct.title,
      };
      bundleProductNames.push(lineItem.product_title);
      bundleVariantNames.push(lineItem.title);
      window.maestro.fireTrackEvent("productAdded", eventData);
    });

    window.maestro.fireTrackEvent("bundleAddedToCart", {
      items: bundleItems,
      bundleProduct,
      cart,
    });
    analytics.track({
      fbq: [
        "trackCustom",
        "AddBundle",
        {
          bundleName: bundleProduct.title,
          bundlePrice: bundleProduct.price,
        },
      ],
      ga: [
        "send",
        {
          hitType: "event",
          eventCategory: "Bundles",
          eventAction: "Added Bundle on PDP",
          eventLabel: bundleProduct.title,
          eventValue: parseInt(bundleProduct.price),
        },
      ],
    });
  } catch (e) {
    console.error(e);
  }
};

export const crossSellPresentedEvent = (
  upsellKey,
  upsellPosition,
  productPrice,
  testVariant
) => {
  window.dispatchEvent(new CustomEvent(`upsell:${upsellKey}`));
  analytics.track({
    ga: [
      "send",
      {
        hitType: "event",
        eventCategory: "In-Cart Upsell",
        eventAction: "Cross-Sell Presented",
        eventLabel: `${upsellKey}:${upsellPosition}${
          testVariant ? ":" + testVariant : ""
        }`,
        eventValue: parseInt(productPrice),
      },
    ],
  });
};

export const crossSellAddedEvent = (
  upsellKey,
  upsellPosition,
  productPrice,
  testVariant
) => {
  analytics.track({
    ga: [
      "send",
      {
        hitType: "event",
        eventCategory: "In-Cart Upsell",
        eventAction: "Cross-Sell Added",
        eventLabel: `${upsellKey}:${upsellPosition}${
          testVariant ? ":" + testVariant : ""
        }`,
        eventValue: parseInt(productPrice),
      },
    ],
  });
};
